var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { CollectionGroup } from './collection-group';
import { getCollectionGroups, cs, retrieveBlocks } from '../utils';
import { useNotionContext } from '../context';
import { CollectionCard } from './collection-card';
import { format } from 'date-fns';
import ChevronRight from '../icons/chevron-right';
import ChevronLeft from '../icons/chevron-left';
function listDates(date, weekStartsOn) {
    if (weekStartsOn === void 0) { weekStartsOn = 0; }
    var lDOTM = 32 - new Date(date.getFullYear(), date.getMonth(), 32).getDate();
    var dates = [];
    for (var i = 1; i <= lDOTM; i++) {
        dates.push(new Date(date.getFullYear(), date.getMonth(), i));
    }
    return padDates(dates, weekStartsOn);
}
function padDates(dates, weekStartsOn) {
    if (weekStartsOn === void 0) { weekStartsOn = 0; }
    // subtracting 1 from the first day of the month automatically starts the
    // week with monday. This is counter intuitive because 6 should be monday by
    // my calculation.It seems like javascript wraps around to - 1 instead of 6.
    weekStartsOn = weekStartsOn === 0 ? 7 : weekStartsOn;
    dates = dates.slice();
    var firstDate = dates[0];
    var i = 0;
    var start = 6 - weekStartsOn;
    while (i < firstDate.getDay() + start) {
        dates.unshift(null);
        i++;
    }
    // replace null with dates from previous month
    var j = 0;
    while (i >= 0) {
        dates[j] = new Date(new Date(firstDate).setDate(firstDate.getDate() - i));
        i--;
        j++;
    }
    i = dates.length;
    j = 1;
    var maxLength = i > 35 ? 42 : 35;
    var lastDate = dates[dates.length - 1];
    while (i < maxLength) {
        dates.push(new Date(new Date(lastDate).setDate(lastDate.getDate() + j)));
        i++;
        j++;
    }
    // remove the first row if they don't belong to the same month
    if (dates[6].getDate() > 7) {
        dates = dates.slice(6);
    }
    // grab the first date
    firstDate = dates.find(function (d) { return d.getDate() === 1; });
    return { firstDate: firstDate, dates: dates, lastDate: lastDate };
}
export function groupBlocksByDate(blocks, property) {
    var _a, _b, _c, _d, _e;
    var dict = {};
    for (var _i = 0, blocks_1 = blocks; _i < blocks_1.length; _i++) {
        var block = blocks_1[_i];
        var dateString = (_e = (_d = (_c = (_b = (_a = block === null || block === void 0 ? void 0 : block.value) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b[property]) === null || _c === void 0 ? void 0 : _c.flat()) === null || _d === void 0 ? void 0 : _d.flat()) === null || _e === void 0 ? void 0 : _e.flat()[2]['start_date'];
        if (!dict[dateString])
            dict[dateString] = [];
        dict[dateString].push(block);
    }
    return dict;
}
export var CollectionViewCalendar = function (_a) {
    var _b;
    var collection = _a.collection, collectionView = _a.collectionView, collectionData = _a.collectionData, padding = _a.padding;
    var isGroupedCollection = (_b = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _b === void 0 ? void 0 : _b.collection_group_by;
    if (isGroupedCollection) {
        var collectionGroups = getCollectionGroups(collection, collectionView, collectionData, padding);
        return collectionGroups.map(function (group, index) { return (React.createElement(CollectionGroup, __assign({ key: index }, group, { summaryProps: {
                style: {
                    paddingLeft: padding
                }
            }, collectionViewComponent: function (props) { return (React.createElement(Calendar, __assign({ padding: padding }, props))); } }))); });
    }
    return (React.createElement(Calendar, { collectionView: collectionView, collection: collection, collectionData: collectionData }));
};
function Calendar(_a) {
    var _b;
    var collectionView = _a.collectionView, collectionData = _a.collectionData, collection = _a.collection;
    var _c = useNotionContext(), recordMap = _c.recordMap, weekStartsOn = _c.weekStartsOn, updateCalendarControls = _c.updateCalendarControls;
    var _d = React.useState(new Date()), startDate = _d[0], setStartDate = _d[1];
    var today = new Date();
    var blocks = retrieveBlocks(collection, collectionView, collectionData, recordMap).map(function (id) { return recordMap.block[id]; });
    var _e = (collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) || {}, _f = _e.calendar_cover, calendar_cover = _f === void 0 ? { type: 'none' } : _f, _g = _e.calendar_cover_size, calendar_cover_size = _g === void 0 ? 'medium' : _g, _h = _e.calendar_cover_aspect, calendar_cover_aspect = _h === void 0 ? 'cover' : _h;
    var properties = (_b = collectionView.format) === null || _b === void 0 ? void 0 : _b.table_properties;
    var property = collectionView.query2.calendar_by;
    var blocksByDate = groupBlocksByDate(blocks, property);
    var daysInAWeek = ['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'];
    var daysOfTheWeek = daysInAWeek.map(function (_, index) { return daysInAWeek[(index + weekStartsOn) % daysInAWeek.length]; });
    var _j = listDates(startDate, weekStartsOn % 7), firstDate = _j.firstDate, dates = _j.dates, lastDate = _j.lastDate;
    var datesAndBlocks = dates.map(function (date) {
        var dateString = format(date, 'yyyy-MM-dd');
        return { date: date, blocks: blocksByDate[dateString] || [] };
    });
    var titleProperty = null;
    for (var _i = 0, _k = properties || []; _i < _k.length; _i++) {
        var property_1 = _k[_i];
        if (property_1.property === 'title') {
            titleProperty = property_1;
            break;
        }
    }
    return (React.createElement("div", { className: 'notion-calendar' },
        React.createElement("div", { className: 'notion-calendar-header' },
            React.createElement("p", { className: 'notion-calendar-header-title' }, format(startDate, 'MMMM yyyy')),
            React.createElement("div", { className: 'notion-calendar-header-controls' },
                React.createElement("span", { onClick: function () {
                        setStartDate(new Date(startDate.getFullYear(), startDate.getMonth() - 1, 1));
                    } },
                    React.createElement(ChevronLeft, { height: 42, width: 42, style: { transform: 'scale(.5)' }, fill: 'currentColor' })),
                React.createElement("span", { onClick: function () { return setStartDate(today); } }, "Today"),
                React.createElement("span", { onClick: function () {
                        setStartDate(new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1));
                    } },
                    React.createElement(ChevronRight, { height: 42, width: 42, fill: 'currentColor', style: { transform: 'scale(.5)' } })))),
        React.createElement("div", { className: 'notion-calendar-body' },
            React.createElement("div", { className: 'notion-calendar-body-title' }, daysOfTheWeek.map(function (day, i) {
                return React.createElement("span", { key: i }, day);
            })),
            React.createElement("div", { className: 'notion-calendar-body-dates' }, datesAndBlocks.map(function (data, i) {
                var _a;
                return (React.createElement("div", { key: i, className: 'notion-calendar-body-dates-block' },
                    React.createElement("span", { className: cs('notion-calendar-body-dates-block-date', firstDate > data.date || data.date > lastDate
                            ? 'notion-calendar-body-dates-block-date--light'
                            : '', format(data.date, 'yyyy-MM-dd') == format(today, 'yyyy-MM-dd')
                            ? 'notion-calendar-body-dates-block-date--today'
                            : '') }, (_a = data.date) === null || _a === void 0 ? void 0 : _a.getDate()),
                    React.createElement("div", { className: 'notion-calendar-body-dates-block-data' }, data.blocks.map(function (block) { return (React.createElement(CollectionCard, { collection: collection, block: block.value, cover: calendar_cover, coverSize: calendar_cover_size, coverAspect: calendar_cover_aspect, properties: titleProperty ? [titleProperty] : [], key: block.value.id })); }))));
            })),
            React.createElement("div", { className: 'notion-calendar-body-dates--mobile' }, datesAndBlocks.map(function (data, i) {
                var _a;
                return (React.createElement("div", { key: i, onClick: function () {
                        return updateCalendarControls({
                            date: data.date,
                            blocks: blocks.map(function (b) { return (__assign(__assign({}, b), { misc: {
                                    collection: collection,
                                    cover: calendar_cover,
                                    size: calendar_cover_aspect,
                                    property: titleProperty ? [titleProperty] : [],
                                    prop: property,
                                    aspect: calendar_cover_aspect
                                } })); })
                        }, true);
                    }, className: 'notion-calendar-body-dates-block' +
                        (data.blocks.length > 0
                            ? ' notion-calendar-body-dates-block--more'
                            : '') },
                    React.createElement("span", { className: cs('notion-calendar-body-dates-block-date', firstDate > data.date || data.date > lastDate
                            ? 'notion-calendar-body-dates-block-date--light'
                            : '', format(data.date, 'yyyy-MM-dd') == format(today, 'yyyy-MM-dd')
                            ? 'notion-calendar-body-dates-block-date--today'
                            : '') }, (_a = data.date) === null || _a === void 0 ? void 0 : _a.getDate())));
            })))));
}
//# sourceMappingURL=collection-view-calendar.js.map